/* eslint-disable react-hooks/exhaustive-deps */
import { urlLabel } from '@/enum/PermissionEnum';
import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

/**
 * Backward compatible route:
 * `/project-cr-consolidation?...` redirects to `/project-cr?...&type=consolidated`
 */
const RedirectToProjectCr = () => {
  const history = useHistory();
  const query = new URLSearchParams(useLocation().search);

  useEffect(() => {
    const requestKey =
      query.get('requestKey') || localStorage.getItem('requestKey') || '';
    const hrEmail = (
      query.get('hrEmail') ||
      localStorage.getItem('hrEmail') ||
      ''
    ).replace(/ /g, '+');
    const projectId = query.get('projectId') || '';

    const qs = new URLSearchParams();
    if (requestKey) qs.set('requestKey', requestKey);
    if (hrEmail) qs.set('hrEmail', hrEmail);
    if (projectId) qs.set('projectId', projectId);
    qs.set('type', 'consolidated');

    history.replace(`/${urlLabel.previewDownloadCRReport}?${qs.toString()}`);
  }, [history]);

  return null;
};

export default RedirectToProjectCr;
